import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { t } from "i18next";
import { forwardRef, useImperativeHandle, useState } from "react";
import { allImages } from "../../assets";
import GlobalButton from "../CustomButton";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const PermissionAlert = forwardRef(({ onAllow }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle
        variant="h1"
        fontWeight={600}
        fontSize={"1.5rem"}
        fontFamily={"inter"}
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
      >
        {paramsData?.heading || t("confirmation")}
      </DialogTitle>
      <DialogContent dividers>
        <Stack alignItems={"center"} justifyContent={"center"}>
          {/* <ReportGmailerrorredIcon
            htmlColor={"red"}
            sx={{
              fontSize: "5rem",
            }}
          /> */}
          <img src={allImages.acceptImage} width={150} />
        </Stack>
        <Typography
          variant={"body1"}
          mt={2.5}
          textAlign={"center"}
          color={"primary.main"}
          fontStyle={"italic"}
        >
          {paramsData?.warningText}
        </Typography>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"custom_outlined"}
          btnText={"close"}
          handleClickBtn={handleClose}
          styleProps={{
            height: 38,
            width: 100,
            borderRadius: "6px",
          }}
        />
        <GlobalButton
          btnText={"upgrade"}
          handleClickBtn={() => onAllow(paramsData)}
          styleProps={{
            height: 38,
            width: 100,
            borderRadius: "6px",
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default PermissionAlert;
